import { VueModule } from '@Foundation';
import TrueOrFalse from './code/Scripts/components/true-or-false';
export default VueModule({
    components: {
        TrueOrFalse

    }
});